var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['label', ("label-pricerequest-status-" + _vm.status)]},[_vm._v(_vm._s(_vm._f("formatLookupName")(_vm.status,_vm.PricingRequestStatusTypeLookup)))])}
var staticRenderFns = []

export { render, staticRenderFns }